import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import AWS from 'aws-sdk'
import { v4 as uuidv4 } from 'uuid'

// import CloseIcon from '@material-ui/icons/Close'

import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Alert from '@material-ui/lab/Alert'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'

import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

import RpcApiClient from 'datasources/RpcApiClient'

import '../filesMenu.css'

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: 200,
    // margin: 'auto',
    '& .MuiOutlinedInput-root': {
      height: 37,
    },
    '& .MuiSelect-outlined': {
      height: 37,
    },
    '& .MuiSelect-select': {
      height: 17,
      maxWidth: 200,
      padding: '0px 40px 0px 10px;',
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 12px) scale(1) !important;',
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75) !important;',
    },
  },
  selectEmpty: {
    // marginTop: theme.spacing(2),
  },
}))

function ShareDialog(props) {
  const [selectedUser, setSelectedUser] = useState('')
  const [dialogOption, setDialogOption] = useState('none')
  const [userInfo, setUserInfo] = useState({ name: '', last_name: '', email: '' })
  const [alerta, setAlerta] = useState({ bool: false, severity: '', message: '' })

  const myBucket = new AWS.S3({})

  // useEffect(() => {
  //   if(props.selectedFile.shared_list !== undefined){
  //     console.log(myBucket)
  //   props.selectedFile.shared_list.length === 0 ? setIsShared(false) : setIsShared(true)
  //   }
  // }, [props.selectedFile])

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY,
  })

  const classes = useStyles()
  const authData = useSelector((state) => state.auth.authData)
  const userCompany = useSelector((state) => state.companyState.id)

  const showUserData = (email) => {
    setSelectedUser(email)
    setUserInfo(props.userList.find((usr) => usr.email === email))
  }

  const shareFile = async () => {
    setDialogOption('loading')

    const fileId = uuidv4()

    const params = {
      ACL: 'public-read',
      Bucket: process.env.REACT_APP_GEOCREATOR_BUCKET_NAME,
      CopySource:
        '/' +
        process.env.REACT_APP_GEOCREATOR_BUCKET_NAME +
        '/' +
        props.selectedFile.key +
        '/' +
        props.selectedFile.id +
        '.geojson',
      Key: userCompany + '/' + fileId + '.geojson',
    }

    const body = {
      data: {
        document_id: fileId,
        file_name: props.selectedFile.name,
        file_type: 'public',
        blocked: false,
        shared_list: [],
        user: authData.email,
        company: userCompany,
        file_key: userCompany,
      },
      options: {
        action: 'create',
      },
    }

    try {
      await myBucket.copyObject(params).promise()

      RpcApiClient.createDocumentGeocreator(authData.jwtToken, body).then(() => {
        setAlerta({ bool: true, severity: 'success', message: 'The Project has been successfully shared.' })
        setDialogOption('public')
        setTimeout(() => {
          setAlerta({ bool: false, severity: '', message: '' })
          setDialogOption('none')
          props.getFiles()
          props.setOpenShare(false)
        }, 3000)
      })
    } catch (err) {
      console.log(err, err.stack)
      setAlerta({ bool: true, severity: 'error', message: 'Something went wrong. Please try again.' })
      setDialogOption('public')
      setTimeout(() => {
        setDialogOption('none')
        setAlerta({ bool: false, severity: '', message: '' })
        props.getFiles()
        props.setOpenShare(false)
      }, 3000)
    }
  }

  const shareFilePrivate = async () => {
    const params = {
      ACL: 'public-read',
      Bucket: process.env.REACT_APP_GEOCREATOR_BUCKET_NAME,
      CopySource:
        '/' +
        process.env.REACT_APP_GEOCREATOR_BUCKET_NAME +
        '/' +
        props.selectedFile.key +
        '/' +
        props.selectedFile.id +
        '.geojson',
      Key: userCompany + '/' + props.selectedFile.id + '.geojson',
    }

    const deleteParams = {
      Bucket: process.env.REACT_APP_GEOCREATOR_BUCKET_NAME,
      Key: props.selectedFile.key + '/' + props.selectedFile.id + '.geojson',
    }
    // console.log(props.selectedFile.key + '/' + props.selectedFile.id + '.geojson')
    const body = {
      data: {
        document_id: props.selectedFile.id,
        file_name: props.selectedFile.name,
        file_type: 'shared',
        shared_list: [authData.email, userInfo.email],
        file_key: userCompany,
      },
      options: {
        action: 'update',
      },
    }

    if (selectedUser.trim() !== '') {
      try {
        setDialogOption('loading')
        await myBucket.copyObject(params).promise()
        await myBucket.headObject(deleteParams).promise()
        await myBucket.deleteObject(deleteParams).promise()

        RpcApiClient.createDocumentGeocreator(authData.jwtToken, body).then(() => {
          setAlerta({ bool: true, severity: 'success', message: 'The Project has been successfully shared.' })
          setDialogOption('private')
          setTimeout(() => {
            setAlerta({ bool: false, severity: '', message: '' })
            setDialogOption('none')
            props.getFiles()
            props.setOpenShare(false)
            setUserInfo({ name: '', last_name: '', email: '' })
            setSelectedUser('')
          }, 3000)
        })
      } catch (error) {
        console.log(error, error.stack)
        setAlerta({ bool: true, severity: 'error', message: 'Something went wrong. Please try again.' })
        setDialogOption('private')
        setTimeout(() => {
          setAlerta({ bool: false, severity: '', message: '' })
          setDialogOption('none')
          props.getFiles()
          props.setOpenShare(false)
          setUserInfo({ name: '', last_name: '', email: '' })
          setSelectedUser('')
        }, 3000)
      }
    } else {
      setAlerta({ bool: true, severity: 'warning', message: 'Select a user first.' })
      setTimeout(() => {
        setAlerta({ bool: false, severity: '', message: '' })
      }, 3000)
    }
  }

  return (
    <Dialog
      open={props.openShare}
      onClose={() => props.setOpenShare(false)}
      style={{ fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif' }}
    >
      <div style={{ flex: '0 0 auto', margin: '0', padding: '16px 24px 10px 16px', fontSize: '14px' }}>
        <h3 style={{ marginBottom: '0px' }}>
          <b>{props.selectedFile.name}</b>
        </h3>
      </div>
      <DialogContent style={{ padding: '5px 8px 15px 8px' }}>
        {dialogOption === 'none' ? (
          <div style={{ flex: '1 1 auto', padding: '0px 24px', fontSize: '15px', color: '#9d9d9d' }}>
            Select <b>Public</b> to allow all your colleagues to see or edit the project.<br></br>
            Select <b>Shared</b> to chose one or more colleagues that will be able to see or edit the project.
          </div>
        ) : dialogOption === 'public' ? (
          <div
            style={{
              flex: '1 1 auto',
              padding: '0px 24px',
              fontSize: '15px',
              color: '#9d9d9d',
              width: '550px',
              display: 'grid',
            }}
          >
            <label>You want to make the {props.selectedFile.name} project public?</label>
            <div style={{ width: '100%', marginTop: '15px' }}>
              {alerta.bool ? (
                <Alert severity={alerta.severity}>{alerta.message}</Alert>
              ) : (
                <div style={{ display: 'flex', gap: '15px', width: '150px', margin: 'auto' }}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    size="small"
                    style={{ color: 'red', borderColor: 'red' }}
                    onClick={() => setDialogOption('none')}
                  >
                    CANCEL
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    style={{ color: '#03a9f4', borderColor: '#03a9f4' }}
                    onClick={() => shareFile()}
                  >
                    SHARE
                  </Button>
                </div>
              )}
            </div>
          </div>
        ) : dialogOption === 'private' ? (
          <div
            style={{
              flex: '1 1 auto',
              padding: '0px 24px',
              fontSize: '15px',
              color: '#9d9d9d',
              width: '550px',
              display: 'grid',
            }}
          >
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel htmlFor="outlined-age-native-simple">Select User</InputLabel>
              <Select
                value={selectedUser}
                onChange={(e) => showUserData(e.target.value)}
                autoWidth={true}
                label="Select User"
              >
                {props.userList.map((usr) => (
                  <MenuItem style={{ fontSize: '14px' }} value={usr.email}>
                    {usr.email}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <div style={{ display: 'grid', gap: '5px', marginTop: '5px' }}>
              <label>
                <b>Name:</b> {userInfo.name}{' '}
              </label>
              <label>
                <b>Last Name:</b> {userInfo.last_name}{' '}
              </label>
              <label>
                <b>E-mail:</b> {userInfo.email}{' '}
              </label>
              {alerta.bool ? (
                <Alert severity={alerta.severity}>{alerta.message}</Alert>
              ) : (
                <div style={{ display: 'flex', gap: '15px', width: '150px', margin: 'auto', marginTop: '15px' }}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    size="small"
                    style={{ color: 'red', borderColor: 'red' }}
                    onClick={() => setDialogOption('none')}
                  >
                    CANCEL
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    style={{ color: '#03a9f4', borderColor: '#03a9f4' }}
                    onClick={() => shareFilePrivate()}
                  >
                    SHARE
                  </Button>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div
            style={{
              flex: '1 1 auto',
              padding: '0px 24px',
              fontSize: '15px',
              color: '#9d9d9d',
              width: '550px',
              display: 'grid',
            }}
          >
            <div style={{ height: '156px', width: '100%', display: 'grid' }}>
              <Spin
                style={{ margin: 'auto', alignSelf: 'center', color: '#03a9f4' }}
                tip="Loading..."
                size="large"
                indicator={<LoadingOutlined />}
              ></Spin>
            </div>
          </div>
        )}
      </DialogContent>
      <DialogActions style={{ background: '#ededf0' }}>
        <button
          style={{ display: 'block', width: '60px', textAlign: 'center' }}
          onClick={() => {
            setDialogOption('none')
            props.setOpenShare(false)
          }}
          className="files-manager-btn-cancel"
        >
          CANCEL
        </button>
        <button
          style={{ display: 'block', width: '60px', textAlign: 'center' }}
          onClick={() => setDialogOption('public')}
          className="files-manager-btn ripple"
        >
          PUBLIC
        </button>
        <button
          style={{ display: 'block', width: '60px', textAlign: 'center' }}
          onClick={() => setDialogOption('private')}
          className="files-manager-btn ripple"
        >
          USER
        </button>
      </DialogActions>
    </Dialog>
  )
}

export default ShareDialog
